// extracted by mini-css-extract-plugin
module.exports = {"mainBox":"page_mainBox__1YGdK","insideBox":"page_insideBox__gA9O7"};